import {loadScript} from '../../helpers/coreUtil'
import {notifyError} from '../../helpers/util'

export const tweetBlotClassName = 'ql-tweet'
let loaded: boolean
let twttr: any
export const loadTwitter = () => new Promise (
  (resolve, reject) => {
    if (loaded) return resolve(twttr)
    if (twttr) return twttr.ready(() => resolve(twttr))
    twttr = {
      _e: [() => resolve(twttr)],
      ready(f: () => any) { twttr._e.push(f) }
    }
    window.twttr = twttr
    void (async () => {
      try {
        await loadScript('https://platform.twitter.com/widgets.js', {async: true, id: 'twitter-wjs'})
        loaded = true
      } catch (e) {
        twttr = undefined
        reject(e)
      }
    })()
  }
)

export const makeTwitterBlot = (BlockEmbed) => {
  class TweetBlot extends BlockEmbed {
    static create(id) {
      let node = super.create()
      // If it is only a number, use it as an id, if it is in the form of a URL, get only the id part.
      id = /^\d+$/.test(id) ? id : new URL(id).pathname.match(/\d*?$/)?.[0]
      node.dataset.id = id
      void (async () => {
        try {
          await window.twttr.widgets.createTweet(id, node, {
            align: 'center'
          })
        } catch (e){
          notifyError(`Can not create tweet id ${id}`)
          // eslint-disable-next-line no-console
          console.error(e) // tslint:disable-line:no-console
        }
      })()
      return node
    }

    static value(domNode) {
      return domNode.dataset.id
    }
  }

  TweetBlot.blotName = 'tweet'
  TweetBlot.tagName = 'div'
  TweetBlot.className = tweetBlotClassName
  return TweetBlot
}

export function twitterHandler() {
  if (!loaded) return notifyError('Twitter is not ready')
  this.quill.theme.tooltip.edit('twitter')
}

export const reloadTweets = (twttr: any, container: HTMLElement) => Promise.all(
  [].map.call(
    container.getElementsByClassName(tweetBlotClassName),
    (el: HTMLElement) => {
      const id = el.getAttribute('data-id')
      if (el.firstChild) el.removeChild(el.firstChild)
      if (id) return twttr.widgets.createTweet(id, el)
    }
  )
)
